// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2c-0";